// Get Discover Link Categories
export const GET_DISCOVER_LINK_CATEGORIES_REQUEST = 'GET_DISCOVER_LINK_CATEGORIES_REQUEST';
export const GET_DISCOVER_LINK_CATEGORIES_DONE = 'GET_DISCOVER_LINK_CATEGORIES_DONE';
export const GET_DISCOVER_LINK_CATEGORIES_FAILED = 'GET_DISCOVER_LINK_CATEGORIES_FAILED';
export const GET_DISCOVER_LINK_CATEGORIES_RESET = 'GET_DISCOVER_LINK_CATEGORIES_RESET';

// Operations
export const DISCOVER_LINK_CATEGORIES_SET_PAGE = 'DISCOVER_LINK_CATEGORIES_SET_PAGE';
